import "./home.css";

import { Link, useLocation } from "react-router-dom";
import { SWButton, SWLink } from "../components/components";
import { useEffect } from "react";
import video from "../components/img/webvideo.mp4";
import { GrassList } from "./GrassList";

import logo from "../components/img/logo.png";
import EventCard from "./Event/EventCard";
import { SponsorList } from "./SponsorList";
import SponsorImg from "./Sponsors/SponsorImg";

function Home() {
	const location = useLocation();
	useEffect(() => {
		if (window.beholdWidgets !== undefined) {
			window.beholdWidgets.initialize();
		}
	}, [location]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<div className="landingcontainer">
				<div className="landingimg">
					<video
						src={video}
						autoPlay={true}
						muted
						controls={false}
						loop={true}
						playsInline
					/>
				</div>
				<div className="imgoverlay">
					<img className="logo" src={logo} />
				</div>
				<div className="captionoverlay">
					{/* <h2 style={{ margin: 0 }}>Tucson, AZ</h2> */}
					<h4 style={{ margin: 0 }}>
						<em>Where the Desert Meets the Grass</em>
					</h4>
				</div>
			</div>
			<div className="content" style={{ textAlign: "center" }}>
				<h1 style={{ marginBottom: 0 }}>Monthly Tournaments in Tucson, AZ</h1>
				<p style={{ marginTop: 0 }}>
					We have competitive "Open" and recreational "B" divisions - so there's
					a spot for you and your team no matter the skill level! Tournaments
					run every month - come out and have some fun, meet new people, and
					play some volleyball!
				</p>
				<hr />
				<h1 style={{ marginBottom: 0 }}>Upcoming Events</h1>
				<div className="eventList">
					<div className="eventListEvents">
						{GrassList.filter((e) => e.past != true && e.visible != false)
							.sort((a, b) => (a.date > b.date ? 1 : -1))
							.map((e) => {
								return <EventCard event={e} />;
							})}
					</div>
				</div>
				<hr />
				<h1 style={{ marginBottom: 0 }}>Past Results</h1>
				<div className="eventList">
					<div className="eventListEvents">
						{GrassList.filter((e) => e.past == true && e.visible != false)
							.sort((a, b) => (a.date > b.date ? -1 : 1))
							.map((e) => {
								return <EventCard event={e} />;
							})}
					</div>
				</div>
				<hr />
				<h1>Our Partners</h1>
				<h2>Title Sponsors</h2>
				<div className="titleSponsors">
					{SponsorList.filter((s) => s.type == "title").map((s) => {
						return <SponsorImg sponsor={s} />;
					})}
				</div>
				<h2>Local Partners</h2>
				<div className="titleSponsors">
					{SponsorList.filter((s) => s.type == "local").map((s) => {
						return <SponsorImg sponsor={s} />;
					})}
				</div>
				<h2>League Partners</h2>
				<h5>
					Click on a logo below to learn more about how to join a local Tucson
					volleyball league!
				</h5>
				<div className="titleSponsors">
					{SponsorList.filter((s) => s.type == "league").map((s) => {
						return <SponsorImg sponsor={s} />;
					})}
				</div>
				<hr />
				<h1>
					Follow us on{" "}
					<a
						href="https://www.instagram.com/sidewinder_va"
						target="_blank"
						rel="noopener noreferrer"
					>
						Instagram!
					</a>
				</h1>
				{/* <figure data-behold-id="X955tRQNhaRc8RDAfQGI"></figure> */}
			</div>
		</div>
	);
}
export default Home;
